export const locale = {
    lang: 'en',
    data: {
        TEAM: 'Team discussion',
        CONVERSATION: 'Start a conversation by typing your message below.',
        TYPE: 'Type your message',
        ANIMATOR_BADGE: 'Facilitator '
    }
};
